"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var styled_components_1 = require("styled-components");

var atoms_icon_1 = __importDefault(require("@lettucegrow/atoms.icon"));

var atoms_text_1 = __importDefault(require("@lettucegrow/atoms.text"));

var atoms_utils_theme_1 = require("@lettucegrow/atoms.utils.theme");

var BackButton_styled_1 = require("./BackButton.styled");

var BackButton = function BackButton(_ref) {
  var label = _ref.label,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? null : _ref$onClick,
      modifiers = _ref.modifiers;
  return react_1.default.createElement(styled_components_1.ThemeProvider, {
    theme: atoms_utils_theme_1.theme
  }, react_1.default.createElement(BackButton_styled_1.BackButtonStyled, {
    onClick: onClick,
    modifiers: modifiers
  }, react_1.default.createElement(atoms_icon_1.default, null, react_1.default.createElement("svg", {
    version: '1.1',
    id: 'Layer_1',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink',
    x: '0px',
    y: '0px',
    viewBox: '0 0 512 512',
    style: {
      enableBackground: 'new 0 0 512 512'
    },
    xmlSpace: 'preserve'
  }, react_1.default.createElement("g", null, react_1.default.createElement("g", null, react_1.default.createElement("path", {
    className: 'st0',
    d: 'M131,263.4l234.7,245.3c4.1,4.2,10.8,4.4,15.1,0.3c4.3-4.1,4.4-10.8,0.3-15.1L153.4,256L381,18\n\t\t\tc4.1-4.3,3.9-11-0.3-15.1c-2.1-2-4.7-3-7.4-3c-2.8,0-5.6,1.1-7.7,3.3L131,248.6C127,252.8,127,259.3,131,263.4z'
  }))))), react_1.default.createElement(atoms_text_1.default, {
    as: 'span',
    content: label
  })));
};

BackButton.propTypes = {
  label: prop_types_1.default.string,
  onClick: prop_types_1.default.func,
  modifiers: prop_types_1.default.any
};
exports.default = BackButton;